import React, { useState } from 'react'
import './ServicesForm1.css'
import { useAlert } from "react-alert";


function ServicesForm1() {


    

    const [firstname, setfirstname] = useState();
    const [lastname, setlastname] = useState();
    const [email, setemail] = useState();
    const [phone, setphone] = useState();
    const [services, setservices] = useState();
    const [soletrader, setsoletrader] = useState();
    const [privatedriver, setprivatedriver] = useState();
    const [deliverydriver, setdeliverydriver] = useState();
    const [cis, setcis] = useState();
    const [taxidriver, settaxidriver] = useState();
    const [onlineseller, setonlineseller] = useState();
    const [other, setother] = useState();
    const [propertyaccount, setpropertyaccount] = useState();
    const [companyname, setcompanyname] = useState();
    const [companynumber, setcompanynumber] = useState();
    const [paye, setpaye] = useState();
    const [message, setmessage] = useState();

    const alert = useAlert();
    const [loading, setloading] = useState(false);




    const formSubmitHondler = async (e) => {
         setloading(true)
        e.preventDefault();

        const res = await fetch('https://ajh-accountant.onrender.com/api/quote-forms',  {

            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data:{
                    firstname, lastname, email, phone, services, soletrader, privatedriver, 
                    deliverydriver, cis, taxidriver, onlineseller, other, propertyaccount, 
                    companyname, companynumber, paye, message
            }
            })
        }).then((response)=>{
            response.json()
setloading(false)
            alert.success("Form Submitted Successfully");

        }).catch((error)=>{
            setloading(true)
            alert.success('Error Occurs Please Try Again After Some Time' , error);
        })

        // const data = await res.json()
        
        setfirstname('');
        setlastname('');
        setemail('');
        setphone('');
        setservices('');
        setsoletrader('');
        setprivatedriver('');
        setdeliverydriver('');
        setcis('');
        settaxidriver('');
        setonlineseller('');
        setother('');
        setpropertyaccount('');
        setcompanyname('');
        setcompanynumber('');
         setpaye('');
        setmessage('');

        // console.log(firstname, lastname, email, phone, services, soletrader, privatedriver, deliverydriver, cis, taxidriver, onlineseller, other, propertyaccount, companyname, companynumber, paye, message)

    }


const servicesfun = (e) => {
    setservices(e.target.value)
    setsoletrader('');
    setprivatedriver('');
    setdeliverydriver('');
    setcis('');
    settaxidriver('');
    setonlineseller('');
    setother('');
    setpropertyaccount('');
    setcompanyname('');
    setcompanynumber('');
    setpaye('');
}




  return (
    <div>
          <div className="container-fluid main-contact-div1 contacts-div1">
              <svg
                  className="contact-vector1 d-sm-block d-none"
                  width="65"
                  height="201"
                  viewBox="0 0 65 201"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M103.476 0.0623773C144.217 1.51047 171.061 37.8544 183.39 76.877C195.394 114.872 192.755 158.559 161.184 182.719C127.602 208.417 81.0343 206.104 46.6254 181.535C11.0388 156.125 -9.07933 112.331 4.02486 70.5016C17.4843 27.5381 58.656 -1.53073 103.476 0.0623773Z"
                      fill="#FFB532"
                  />
              </svg>

              <div className="container main-contact-div2">
                  <h1 className=" contactus-text1 ">
                      Get In Touch With <span>US</span>.
                  </h1>
                  <div className="contactus-btn-div">
                      <a href="tel:+44 01204 840303">
                          <div className="contact-btn1">
                              <p className="contactus-text2 text-center">+44 01204 840303</p>
                          </div>
                      </a>
                      <a href="mailto:info@ajhaccountant.co.uk">
                          <div className="contact-btn2">
                              <p className="contactus-text2">info@ajhaccountant.co.uk</p>
                          </div>
                      </a>
                  </div>

                  <div>
                      <form className="contact-form" onSubmit={formSubmitHondler} >
                          <div class="row">
                              <div class="col-lg-6 col-12 ">
                                <label  className='form-labels'>First Name</label>
                                  <input
                                      type="text"
                                      name="firstname"
                                      class="form-control contact-input-field5"
                                      value={firstname}
                                      placeholder="First Name"
                                      onChange={(e) => setfirstname(e.target.value)}
                                     
                                  />
                              </div>
                              <div class="col-lg-6 col-12 mt-4 mt-lg-0">
                                 <label  className='form-labels'>Last Name</label>
                                  <input
                                      type="text"
                                      name="lastname"
                                      class="form-control contact-input-field5"
                                      placeholder="Last Name"
                                      onChange={(e) => setlastname(e.target.value)}
                                      value={lastname}

                                  />
                              </div>
                              <div class="col-lg-6 col-12 mt-4">
                                <label  className='form-labels'>Email Address</label>
                                  <input
                                      type="email"
                                      name="email"
                                      class="form-control contact-input-field5"
                                      placeholder="E-Mail"
                                      onChange={(e) => setemail(e.target.value)}
                                      value={email}

                                  />
                              </div>
                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Phone Number</label>

                                  <input
                                      type="number"
                                      name="phone"
                                      class="form-control contact-input-field5"
                                      placeholder="Phone Number"
                                      onChange={(e) => setphone(e.target.value)}
                                      value={phone}

                                  />
                              </div>

                              <div class="col-lg-12 col-12 mt-4">
                                  <label className='form-labels' >Services</label>
                                  <select class="form-control contact-input-field5" value={services} name='services' onChange={servicesfun}>
                                      <option selected disabled>Choose Services ...</option>
                                      <option value="Self Assesment">Self Assesment</option>
                                      <option value="Property Accounts">Property Accounts</option>
                                      <option value="Limited Accounts">Limited Accounts</option>
                                      <option value="Paye">Paye</option>
                                  </select>
                              </div>

                              <div className={`${services == "Self Assesment"
                                  ? "col-lg-6 col-12 mt-4 d-block"
                                      : "d-none"
                                  }`}>
                                  <label className='form-labels'>Sole Trader</label>

                                  <input
                                      type="text"
                                      name="soletrader"
                                      class="form-control contact-input-field5"
                                      placeholder="Sole Trader"
                                      onChange={(e) => setsoletrader(e.target.value)}
                                      value={soletrader}
                                  />
                              </div>

                              <div className={`${services == "Self Assesment"
                                  ? "col-lg-6 col-12 mt-4 d-block"
                                      : "d-none"
                                  }`}>
                                  <label className='form-labels'>Private Hire Driver</label>

                                  <input
                                      type="text"
                                      name="privatedriver"
                                      class="form-control contact-input-field5"
                                      placeholder="Private Hire Driver"
                                      onChange={(e) => setprivatedriver(e.target.value)}
                                      value={privatedriver}
                                  />
                              </div>

                              <div className={`${services == "Self Assesment"
                                  ? "col-lg-6 col-12 mt-4 d-block"
                                  : "d-none"
                                  }`}>
                                  <label className='form-labels'>Delivery Driver</label>

                                  <input
                                      type="text"
                                      name="deliverydriver"
                                      class="form-control contact-input-field5"
                                      placeholder="Delivery Driver"
                                      onChange={(e) => setdeliverydriver(e.target.value)}
                                      value={deliverydriver}
                                  />
                              </div>

                              <div className={`${services == "Self Assesment"
                                  ? "col-lg-6 col-12 mt-4 d-block"
                                  : "d-none"
                                  }`}>
                                  <label className='form-labels'>CIS</label>

                                  <input
                                      type="text"
                                      name="cis"
                                      class="form-control contact-input-field5"
                                      placeholder="CIS"
                                      onChange={(e) => setcis(e.target.value)}
                                      value={cis}
                                  />
                              </div>
                              <div className={`${services == "Self Assesment"
                                  ? "col-lg-6 col-12 mt-4 d-block"
                                  : "d-none"
                                  }`}>
                                  <label className='form-labels'>Taxi Driver</label>

                                  <input
                                      type="text"
                                      name="taxidriver"
                                      class="form-control contact-input-field5"
                                      placeholder="Taxi Driver"
                                      onChange={(e) => settaxidriver(e.target.value)}
                                      value={taxidriver}
                                  />
                              </div>
                              <div className={`${services == "Self Assesment"
                                  ? "col-lg-6 col-12 mt-4 d-block"
                                  : "d-none"
                                  }`}>
                                  <label className='form-labels'>Online Seller</label>

                                  <input
                                      type="text"
                                      name="onlineseller"
                                      class="form-control contact-input-field5"
                                      placeholder="Online Seller"
                                      onChange={(e) => setonlineseller(e.target.value)}
                                      value={onlineseller}
                                  />
                              </div>

                              <div className={`${services == "Self Assesment"
                                  ? "col-lg-6 col-12 mt-4 d-block"
                                  : "d-none"
                                  }`}>
                                  <label className='form-labels'>Other</label>

                                  <input
                                      type="text"
                                      name="other"
                                      class="form-control contact-input-field5"
                                      placeholder="Other"
                                      onChange={(e) => setother(e.target.value)}
                                      value={other}
                                  />
                              </div>

                              <div className={`${services == "Property Accounts"
                                  ? "col-lg-12 col-12 mt-4 d-block"
                                  : "d-none"
                                  }`}>
                                  <label className='form-labels'>Property Accounts</label>

                                  <input
                                      type="text"
                                      name="propertyaccount"
                                      class="form-control contact-input-field5"
                                      placeholder="Property Accounts"
                                      onChange={(e) => setpropertyaccount(e.target.value)}
                                      value={propertyaccount}
                                  />
                              </div>

                              <div className={`${services == "Limited Accounts"
                                  ? "col-lg-6 col-12 mt-4 d-block"
                                  : "d-none"
                                  }`}>
                                  <label className='form-labels'>Company Name</label>

                                  <input
                                      type="text"
                                      name="companyname"
                                      class="form-control contact-input-field5"
                                      placeholder="Company Name"
                                      onChange={(e) => setcompanyname(e.target.value)}
                                      value={companyname}
                                  />
                              </div>

                              <div className={`${services == "Limited Accounts"
                                  ? "col-lg-6 col-12 mt-4 d-block"
                                  : "d-none"
                                  }`}>
                                  <label className='form-labels'>Company Number</label>

                                  <input
                                      type="number"
                                      name="companynumber"
                                      class="form-control contact-input-field5"
                                      placeholder="Company Number"
                                      onChange={(e) => setcompanynumber(e.target.value)}
                                      value={companynumber}
                                  />
                              </div>

                              <div className={`${services == "Paye"
                                  ? "col-lg-12 col-12 mt-4 d-block"
                                  : "d-none"
                                  }`}>
                                  <label className='form-labels'>Paye</label>

                                  <input
                                      type="text"
                                      name="paye"
                                      class="form-control contact-input-field5"
                                      placeholder="Paye"
                                      onChange={(e) => setpaye(e.target.value)}
                                      value={paye}
                                  />
                              </div>



                              <div className='col-12 mt-4 '>
                                  <label className='form-labels'>Message</label>

                                  <textarea name="message" value={message}  onChange={(e) => setmessage(e.target.value)} id="" cols="20" rows="5" class="form-control contact-input-field5"></textarea>
                              </div>

                              <div className="col-12 mt-4 contact-us-btn-div2">
                                  <button
                                      type="submit"
                                      className="ml-sm-auto mx-sm-0 mx-auto contactus-form-btn4 mb-4"
                                  >
                                      {loading ? "Please Wait..." : 'Submit'}
                                  </button>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
    </div>
  )
}

export default ServicesForm1
